import React from 'react';
import { HeroSection } from './HeroSection';
import { Section2 } from './Section2';
import { Section3 } from './Section3';
import { Section4 } from './Section4';
import { Section5 } from './Section5';

export const Landing = () => {
  return (
    <div>
      <HeroSection />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
    </div>
  );
};
